import script from "./ImportData.vue?vue&type=script&setup=true&lang=js"
export * from "./ImportData.vue?vue&type=script&setup=true&lang=js"

import "./ImportData.vue?vue&type=style&index=0&id=3ce54444&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ce54444"]])

export default __exports__